import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);
const vRouter = new VueRouter({
  mode: 'history',  //去掉url中的#
  routes: [
    {
      path: '/login',
      name: '登录',
      meta: {requireAuth: true, keepAlive : true},
      component: resolve => require(['@eastTrans/views/login/new'],resolve),
    },
    {
      path: '/panel_p',
      name: '项目大屏',
      meta: {requireAuth: true, keepAlive : true},
      component: resolve => require(['@comm/components/panel/index_p'],resolve),
    },
    {
      path: '/panel',
      name: '标段大屏',
      meta: {requireAuth: true, keepAlive : true},
      component: resolve => require(['@comm/components/panel'],resolve),
    },
    {
      path: '/',
      name: '项目入口',
      redirect:"/project",
      meta: {requireAuth: true, keepAlive : true},
      component: resolve => require(['@comm/components/Entrance/index'],resolve),
      children:[
        {
          path: '/project',
          name: '项目首页',
          component: resolve => require(['@comm/components/Entrance/projectHome/index'],resolve),
          meta: {requireAuth: true , keepAlive : true},
        },
        {
          path:'/historical/details',
          name:'recordsDetails',
          component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/records/components/details/index'],resolve),
          meta: {requireAuth: true, keepAlive : false}
        },
        {
          path: '/sectionHome',
          name: '标段入口',
          redirect:"/section",
          component: resolve => require(['@comm/components/Entrance/section/index'],resolve),
          meta: {requireAuth: true, keepAlive : true},
          children:[
            {
              path: '/section',
              name:'标段首页',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/index'],resolve),
              meta: { requireAuth: true, keepAlive : true},
            },
            {
              path: '/home',
              name:'总览页',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/home/index'],resolve),
              meta: { requireAuth: true, keepAlive : true},
            },
            {
              path: '/device',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/device/index'],resolve),
              name:'设备监控',
              redirect:"/device/list",
              meta: { requireAuth: true , keepAlive : false},
              children:[
                {
                  path:'/device/list',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/device/components/deviceList'],resolve),
                  name:'设备列表',
                  meta: {requireAuth: true, keepAlive : false},
                },
                {
                  path:'/device/map',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/device/components/deviceMap'],resolve),
                  name:'设备地图',
                  meta: {requireAuth: true, },
                }
              ]
            },
            {
              path: '/configure',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/configure/index'],resolve),
              name:'作业配置',
              meta: { requireAuth: true , keepAlive : true}
            },
            {
              path: '/historical',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/records/index'],resolve),
              name:'生产记录',
              meta: { requireAuth: true , keepAlive : true}
            },
            {
              path: '/early-warning',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/alarm/index'],resolve),
              name:'预警',
              redirect:'/early-warning/information',
              meta: { requireAuth: true , keepAlive : true},
              children:[
                {
                  path:'/early-warning/alarm',
                  name:'报警信息',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/alarm/components/alarmMessage.vue'],resolve),
                  meta: {requireAuth: true, keepAlive : true}
                },
                {
                  path:'/early-warning/information',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/alarm/components/information'],resolve),
                  name:'预警信息',
                  meta:{requireAuth: true, keepAlive : true}
                }
              ]
            },
            {
              path: '/document',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/file/index'],resolve),
              name:'文档资料',
              meta: { requireAuth: true , keepAlive : true}
            },
            {
              path: '/effect',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/effect/index'],resolve),
              name:'作业成效',
              redirect:'/effect/single',
              meta: { requireAuth: true , keepAlive : true},
              children:[
                {
                  path:'/effect/single',
                  name:'周成效',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/effect/components/single'],resolve),
                  meta: {requireAuth: true, keepAlive : true}
                },
                {
                  path:'/effect/cumulative',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/effect/components/cumulative'],resolve),
                  name:'月成效',
                  meta:{requireAuth: true, keepAlive : true}
                }
              ]
            },
            {
              path: '/image-data',
              component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/imageData/index'],resolve),
              name:'影像资料',
              meta: { requireAuth: true , keepAlive : true},
              redirect:'/image-data/picture',
              children:[
                {
                  path:'/image-data/picture',
                  name:'图片资料',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/imageData/components/picture.vue'],resolve),
                  meta: {requireAuth: true, keepAlive : true}
                },{
                  path:'/image-data/video',
                  name:'影像资料',
                  component:resolve => require(['@comm/components/Entrance/section/sectionHome/modular/imageData/components/video.vue'],resolve),
                  meta: {requireAuth: true, keepAlive : true}
                },
                {
                  path:'/image-data/panorama',
                  component: resolve => require(['@comm/components/Entrance/section/sectionHome/modular/imageData/components/panorama.vue'],resolve),
                  name:'全景图片',
                  meta:{requireAuth: true, keepAlive : true}
                },
              ]
            }
          ]
        }
      ]
    },
  ]
});

vRouter.beforeEach(function (to,from,next) {
  if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
    let isLogin = sessionStorage.getItem('token');
    if(isLogin){
      next();
    }else{
      if(to.path=='/login'){//如果是登录页面路径，就直接next()
        next();
      }else{//不然就跳转到登录；
        next('/login');
      }
    }
  }
  else {
    next();
  }
});
export default vRouter



// WEBPACK FOOTER //
// ./src/eastTrans/router/index.js